import React from "react"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { Spacer } from "../atoms/Atoms"
import L10n from "../../../lib/carrot-l10n"
import { Body, BodyLarge } from "../atoms/Bodies"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { getSupportCenterLink, SupportCenterLinks } from "../../../utils/SupportCenterLinks"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const WhyAreWeAskingModule = () => {
  return (
    <RoundedRectangle backgroundColor="light-gray">
      <RRIconBar iconName="icn-help" iconBackgroundColor="white" />
      <BodyLarge color="black-80">{l`Why are you asking these questions?`}</BodyLarge>
      <Spacer height={1} />
      <Body color="black-80">
        {l`These questions help us determine whether care or services are taxable, which allows us to quickly and
           accurately process your reimbursements in a legally compliant way.`}
      </Body>
      <Spacer height={1} />
      <ArrowLink
        to={getSupportCenterLink(SupportCenterLinks.WHY_ARE_YOU_ASKING_INFERTILITY_OR_MEDICAL)}
      >{l`Read more`}</ArrowLink>
      <Spacer height={0.5} />
      <ArrowLink to="/talk-to-carrot">{l`Still have questions? Talk to Carrot`}</ArrowLink>
    </RoundedRectangle>
  )
}

export { WhyAreWeAskingModule }
